import { ConfigType } from '@provider-portal/common/config';
import { Observable } from 'rxjs';
import { ignoreElements, tap } from 'rxjs/operators';

import { Bugsnag } from '@bolteu/bugsnag-service-react-web';

import { GlobalAppActions } from 'rdx/actions';
import { injectAppPropertiesPlugin } from 'services/bugsnagPlugins/inject-app-properties';
import { stripPathVersionsPlugin } from 'services/bugsnagPlugins/strip-path-versions';

export const createBugsnagStuff = (config: ConfigType) => {
  const isDevMode = process.env.REACT_APP_STAGE !== 'live';
  const bugsnag = new Bugsnag.Service({
    apiKey: config.bugsnag.apiKey,
    // Note: not providing the "real" app version here because
    //  without the module versions, it only provides partial information
    appVersion: config.version!,
    isDevMode,
    customPlugins: [injectAppPropertiesPlugin, stripPathVersionsPlugin],
  });

  const getBreadcrumbTypeFromAction = (_action: GlobalAppActions): string => {
    return 'log';
  };

  const bugsnagEpic = (actions$: Observable<GlobalAppActions>) =>
    actions$.pipe(
      tap((action) =>
        bugsnag.leaveBreadcrumb(action.type, {
          type: getBreadcrumbTypeFromAction(action),
        }),
      ),
      ignoreElements(),
    );

  const { ErrorBoundary } = bugsnag.getReactBindings(bugsnag);

  return {
    bugsnag,
    ErrorBoundary,
    bugsnagEpic,
  };
};
